import React from "react";

interface ServiceBadgeProps {
  service: any;
}

const ServiceBadge: React.FC<ServiceBadgeProps> = ({ service }) => {
  const packageName = service?.packageName || service?.serviceName || "Service";
  const customerName = service?.customerName || service?.clientName || "Customer";
  const petName = service?.petName ? ` (${service.petName})` : "";
  const time = service?.startTime || service?.serviceTime || "";

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-md p-1.5 text-xs text-amber-900 truncate shadow-xs">
      <div className="font-semibold truncate">
        {customerName}{petName}
      </div>
      <div className="text-[10px] text-amber-700 truncate">
        {packageName} {time ? `• ${time}` : ""}
      </div>
    </div>
  );
};

export default ServiceBadge;